import { Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Component({
    selector: "maaler-oprettelse",
    templateUrl: "./maaler-oprettelse.component.html",
    styleUrls: ["./maaler-oprettelse.component.scss"]
})
export class MaalerOprettelseComponent {
    @Input() public formGroup: UntypedFormGroup;

    public toggleAlphaNumeric(): void {
        const control = this.formGroup.get("maalerNrAlphaNumeric");
        control.setValue(!control.value);
    }

    public isAlphaNumeric(): boolean {
        return !!this.formGroup.get("maalerNrAlphaNumeric").value;
    }
}
